import { useState, useEffect } from 'react'
import { useScrollPosition } from '@n8tb1t/use-scroll-position'

import './App.css';
import ciracenter from './assets/img/cira-center.jpg';
import mod from './assets/img/modx24.png';

import { useInView } from 'react-intersection-observer';


const useMounted  = () => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setTimeout(() => setMounted(true), 350)
  })

  return mounted
}

const Knuckles = (props) => {
  const { inView, ref } = useInView({
    /* Optional options */
    threshold: 0.45,
  });



  useEffect(() => {
    props.setInview(inView)
  }, [inView])

  

  return <div ref={ref} style={{transition: 'opacity 0.3s', opacity: inView ? 1 : 0, zIndex: 10, pointerEvents: inView ? 'auto' : 'none', background:'#fefcfe', position:'relative', width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
    <div style={{background: 'white', position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh'}} />
    <img style={{position: 'relative', width: 100}} src="https://themoderati.com/knuckles.gif" />
  </div>
}

function App() {
  const [ scrollTop, setScrollTop ] = useState(0)
  const [ inView, setInview ] = useState(false)

  useScrollPosition(({ prevPos, currPos }) => {
    setScrollTop(currPos.y)
  })

  const scrollPercent = Math.min(-scrollTop, 500) / 500

  const bgProps = {
    opacity: Math.max(0, 0.15 - scrollPercent * 0.15),
    transform: `translateY(-${scrollPercent * 0.05 * 100}%)`
  }

  const showContent = scrollTop < -175

  const mounted = useMounted()
  return (
    <div className={"App" + (showContent ? ' show' : '')+ (mounted ? ' mounted' : '')}>
      <header className="App-header">

        <div className="gradient" />
        <div className="logo-container">
          <img className="bg" src={ciracenter} style={bgProps} alt='' />
          <img src={mod} alt='MODx24' className="logo" />
          {/* <span className="avenir" style={{textTransform: 'uppercase'}}>
            All Hands 2024
          </span> */}
        </div>

        <nav className="avenir">
          <button onClick={() => { document.querySelector('#agenda').scrollIntoView({behavior: 'smooth'}) }}>Agenda</button>
          <button onClick={() => { document.querySelector('#food').scrollIntoView({behavior: 'smooth'}) }}>Refreshments</button>
          <button onClick={() => { document.querySelector('#hunt').scrollIntoView({behavior: 'smooth'}) }}>Activity</button>
        </nav>
      </header>

      <section className="avenir" style={{color: 'white', marginTop: '4rem',}}>
        <h2 id="agenda">Agenda</h2>
        <p>
          CYTO | PHL<br/>
          Cira Centre<br/>
          2929 Arch Street<br/>
          Philadelphia, PA
        </p>

  <div className="time-row fifteen break"><h3>8:15</h3><p>Arrive</p></div>
<div className="time-row thirty break"><h3>8:30</h3><p>Breakfast </p></div>
<div className="time-row fifteen"><h3>9:00</h3><p>Kickoff with the Kelseys</p></div>
<div className="time-row fifteen"><h3>9:15</h3><p>All In</p></div>
<div className="time-row twenty"><h3>9:30</h3><p>Embracing our Vision: All In 2024</p></div>
<div className="time-row twenty"><h3>9:50</h3><p>Are Those MOD Briefs You’re Wearing?</p></div>
<div className="time-row twenty break"><h3>10:10</h3><p>Break</p></div>
<div className="time-row fifteen"><h3>10:30</h3><p>All In Swiss Design</p></div>
<div className="time-row twenty"><h3>10:45</h3><p>Fuck Good Enough</p></div>
<div className="time-row fifteen break"><h3>11:05</h3><p>Break</p></div>
<div className="time-row thirty"><h3>11:20</h3><p>MOD Mise En Place</p></div>
<div className="time-row hour break"><h3>11:50</h3><p>Lunch</p></div>
<div className="time-row fourty"><h3>12:50</h3><p>All In on Internal + External Relationships</p></div>
<div className="time-row thirty"><h3>1:30</h3><p>Let's Grow Together... 1 Nugget at a Time</p></div>
<div className="time-row fifteen break"><h3>2:00</h3><p>Break</p></div>
<div className="time-row fourtyfive"><h3>2:15</h3><p>All In Vision Boards</p></div>
<div className="time-row five"><h3>3:00</h3><p>Recap & Sizzle</p></div>
<div className="time-row fifteen"><h3>3:05</h3><p>Closing & Gift</p></div>
<div className="time-row hour break"><h3>3:20</h3><p>Happy Hour at Cyto</p></div>
<div className="time-row break"><h3>4:30</h3><p>Barcade</p></div>


        <h2 id="food">Refreshments</h2>

        <h4>Continental Breakfast</h4>
        <p>Parfait<span>Greek yogurt, berries, house made granola</span></p>
        <p>Fruit kind bars</p>
        <p>Pastries</p>
        <p>Bagels</p>
        <p>Le Bus</p>

        <h4 className='space-above'>Lunch</h4>
        <p className='description'>Gourmet Sandwich & Salad buffet with fresh baked cookies and bars</p>

        <h5>Sandwiches</h5>
        <p>Petit Filet<span>Horseradish Cream & Crispy Onion Aioli</span></p>
        <p>Smoked Turkey & Brie<span>Cranberry Chutney</span></p>
        <p>Marinated Grilled Chicken Breast<span>Roasted Peppers & Fresh Mozzarella</span></p>
        <p>Grilled Chicken Caesar Salad Wrap<span>Horseradish Cream & Crispy Onion Aioli</span></p>
        <p>Oven Roasted Turkey BLT<span>Bacon, Lettuce, Herb Mayonnaise</span></p>
        <p>Grilled Vegetable & Heirloom Tomato<span>Smoked Mozzarella<br/><i>*available vegan without cheese</i></span></p>
        <p>Gourmet Vegan Special<span>Roasted Red Peppers, Apple Cider and Brown Sugar Cabbage Slaw, Caramelized Fennel Compote<br/><i>*vegan</i></span></p>

        <h5>Salads</h5>
        <p>Chicken Waldorf Salad</p>
        <p>Mediterranean Tuna Salad<span>Olives, Red Onions, Sundried Tomatoes</span></p>

        <h2 id="hunt">Activity</h2>
        <h4 className='sub-title'>All-In Scavenger Hunt</h4>
        <p className='description'>* Please submit your cards and leave your Polaroid in the bowl</p>
          <h4 className='less-padding'>Tag You’re It</h4>
          <p className="less-padding">Take a photo and tag<br/> <b>@themoderatiofficial</b><br/>and <b>#ALLIN</b></p>

          <h4 className='less-padding'>Riddle Me This</h4>
          <p className="less-padding">If your uncle’s sister is not your aunt, then who is she to you?</p>

          <h4 className='less-padding'>Sign on the<br/>Dotted Line</h4>
          <p className="less-padding">Get your boss’s John Hancock</p>

          <h4 className='less-padding'>I Spy with my<br/>Little Eye</h4>
          <p className="less-padding">Keep an eye out for 5 Swiss items throughout the day</p>

          <h4 className='less-padding'>Shake it Like a Polaroid Picture</h4>
          <p className="less-padding">We’re throwing it back - snap a pic with your work bestie(s)</p>

      </section>
      <Knuckles setInview={setInview}/>
    </div>
  );
}

export default App;
